import React, { useState, useEffect } from 'react';
import stories from './Story.json';
import './Story.css';

function Story() {
  const [selectedId, setSelectedId] = useState('');
  const story = stories.find(s => s.id === selectedId);

 useEffect(() => {
  const loadVoices = () => {
    const voices = window.speechSynthesis.getVoices();
    if (voices.length === 0) {
      setTimeout(loadVoices, 100);
    }
  };
  loadVoices();
}, []);


  const speak = (text, langCode) => {
  const synth = window.speechSynthesis;
  const voices = synth.getVoices();

  // Match voice by language code
  const voice = voices.find(v => v.lang === langCode);

  

  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = langCode;
  if (voice) utterance.voice = voice;

  synth.speak(utterance);
};


  return (
    <div className="app">
      <h1>📚 Story Teller</h1>
      <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>

        
        <option value="">Select a story</option>
        {stories.map(s => (
          <option key={s.id} value={s.id}>{s.title}</option>
        ))}
      </select>

      {story && (
        <div className="story-container">
          {/* English */}
          <div className="language-block">
            <h2>{story.title}</h2>
            {story.english.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.english.moralHeading}</h3>
            <p>{story.english.moral}</p>
            

<button onClick={() => speak([...story.english.lines, story.english.moral].join(' '), 'en-US')}>🔊 Read Aloud (English)</button>


          </div>

          {/* Hindi */}
          <div> <h1><u>In Hindi</u></h1></div>
          <div className="language-block">
            <h2>{story.hindi.title}</h2>
            {story.hindi.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.hindi.moralHeading}</h3>
            <p>{story.hindi.moral}</p>
            <button onClick={() => speak([...story.hindi.lines, story.hindi.moral].join(' '), 'hi-IN')}>🔊 Read Aloud (Hindi)</button>

          </div>

          {/* Telugu */}
<div> <h1><u>In Telugu</u></h1></div>      
    <div className="language-block">
            <h2>{story.telugu.title}</h2>
            {story.telugu.lines.map((line, i) => <p key={i}>{line}</p>)}
            <h3>{story.telugu.moralHeading}</h3>
            <p>{story.telugu.moral}</p>

            <button onClick={() => speak([...story.telugu.lines, story.telugu.moral].join(' '), 'te-IN')}>🔊 Read Aloud (Telugu)</button>

            
          </div>
        </div>
      )}
    </div>
  );
}

export default Story;


